import { TradeKey } from "./api"

export type MarketId = 'binance' | 'bybit' | 'okx'
export type BoardId = 'usdm' | 'linear' | 'swap'

export enum Markets {
  bybit = 'bybit',
  binance = 'binance',
  okx = 'okx',
}

export enum FeatureName {
  changeActiveKey = 'changeActiveKey',
  changeActiveSymbol = 'changeActiveSymbol',
  changeSymbolsSort = 'changeSymbolsSort',
  symbolsSearch = 'symbolsSearch',
  changeSymbolsWatchlist = 'changeSymbolsWatchlist',
  support = 'support',
  changeAiMenu = 'changeAiMenu',
}

export interface TradeKeyWithPermissions extends TradeKey {
  canRead: boolean
  canTrade?: boolean
  ips?: string[]
  permissions?: Record<string, any>
  isDemo?: boolean
}

export interface Sort<T extends string> {
  column: T
  asc: boolean
}

export type Theme = 'light' | 'dark'
